/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Billing_PendingInputs */



/**
* | output |
* | --- |
* | "Called off a scheduled plan change" |
*
* @param {Activity_Billing_PendingInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_billing_pending = /** @type {((inputs?: Activity_Billing_PendingInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Billing_PendingInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отменено запланированное изменение тарифа")
	return /** @type {LocalizedString} */ ("Called off a scheduled plan change")
});